
import yup from "src/utils/yup/extensionMethods";

export const deleteSchema = (translate: Function) => yup.object().shape({
	paa001Grupo: yup.string()
		.required(translate("Nome do grupo não confere"))
		.oneOf([yup.ref("paa001GrupoConfirmation")], translate("Nome do grupo não confere"))
});

export const AddOrChangeSchema = (translate: Function) => yup.object().shape({
	paa001Grupo: yup.string()
		.required(translate("Nome é requerido")),
	paa001Descricao: yup.string()
		.required(translate("Descrição é requerido"))
});

export const parameterSchema = (translate: Function) => yup.object().shape({
	paa002Parametro: yup.number()
		.typeError(translate("O campo parâmetro é numérico"))
		.required(translate("Parâmetro é requerido")),
	paa002Descricao: yup.string()
		.required(translate("Descrição é requerido")),
	paa002Tipo: yup.string()
		.required(translate("O Tipo é requerido"))
		.oneOf(["1","2"], translate("O tipo é inválido")),
	options:yup.array()
		.of(patba003Schema(translate))
		.when("paa002Tipo",
			(type,schema) => type==="1"? 
				schema.min(1,translate("Ao menos uma opção deve ser informada"))
					.required(translate("Ao menos uma opção deve ser informada"))
				:schema)
		
});

const patba003Schema = (translate: Function) => yup.object().shape({
	paa003Descricao: yup.string()
		.required(translate("Descrição é requerido")),
	paa003Valor: yup.string()
		.required(translate("Valor é requerido"))
});
